import "./fake-db";
import { FC, useEffect, useRef } from "react";
import RTL from "./components/RTL";
import { gullTheme } from "./theme";
import { ThemeProvider } from "@mui/system";
import { CssBaseline } from "@mui/material";
import { useLocation, useRoutes } from "react-router-dom";
import { all_routes } from "./routes/routes";
import { CommonContextProvider } from "./contexts/CommonContext";
import useThemeContext from "./hooks/useThemeContext";

const App: FC = () => {
  const all_pages = useRoutes(all_routes);
  const { isRtl, darkMode } = useThemeContext();
  // App theme
  const theme = gullTheme({
    theme: darkMode || "LIGHT",
    direction: isRtl || "ltr",
    roundedCorners: true,
    responsiveFontSizes: true,
  });

  const location = useLocation();
  const prevLocation: any = useRef();

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      window.scrollTo(0, 0);
      prevLocation.current = location.pathname;
    }
  }, [location]);

  return (
    <CommonContextProvider>
      <ThemeProvider theme={theme}>
        <RTL direction={theme.direction}>
          <CssBaseline />
          {all_pages}
        </RTL>
      </ThemeProvider>
    </CommonContextProvider>
  );
};

export default App;
